import { MNHotInstance } from '../../tableHotInstanceTypes';

/**
 * Returns the Handsontable root DOM element for a HOT instance.
 */
const getHotRootContainerFromHotInstance = (hotInstance: MNHotInstance): HTMLDivElement | null =>
    hotInstance.rootContainer as HTMLDivElement;

/**
 * Returns the `.HotTable` wrapper element for a HOT instance.
 */
export const getHotTableElementFromHotInstance = (hotInstance: MNHotInstance): HTMLDivElement | null =>
    getHotRootContainerFromHotInstance(hotInstance)?.parentElement as HTMLDivElement;

/**
 * Returns the outer Milanote table element for a HOT instance.
 */
export const getTableElementFromHotInstance = (hotInstance: MNHotInstance): HTMLDivElement | null =>
    getHotTableElementFromHotInstance(hotInstance)?.parentElement as HTMLDivElement;
